import React from 'react'

import ReactWhatsapp from "react-whatsapp";


import sareedurgapuja from "../images/DURGA PUJA ADS Black red color saree.jpg";
import yellowsaree from "../images/DURGA PUJA ADS yellow saree.jpg";
import tredingfashionkarimpur from "../images/DURGA PUJA ADS DURGA PUJA ADS White Dress Trending.jpg";
import Durgapujareddress_womens from "../images/DURGA PUJA ADS Red dress.jpg";

import purpledress from "../images/DURGA PUJA ADS Purple color.jpg"
import redpinkprnited from "../images/DURGA PUJA ADS Pink Saree printed.jpg";
import churidar from "../images/DURGA PUJA ADS CHURIDAR DEEP green.jpg";
import Churidarwhite from "../images/DURGA PUJA ADS White Dress.jpg";

import lightpurple from "../images/DURGA PUJA ADS Ligh Purple Dress.jpg"
import maroondress from "../images/DURGA PUJA ADS Maroon Dress.jpg"

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'






function Durgapuja2025() {
    return (
        <div>

          
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={sareedurgapuja} className="card-img-top" alt="sareedurgapuja"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Trending Saree </h5>
                                                <p className="card-text">2025 Durga Puja New Collection</p>
                                             

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                 
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={yellowsaree} className="card-img-top" alt="yellowsaree"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Yellow Saree Collection  </h5>
                                                <p className="card-text">2025 Durga Puja New Collection</p>
                                              
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={tredingfashionkarimpur} className="card-img-top" alt="tredingfashionkarimpur"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Smart Look Dresses</h5>
                                                <p className="card-text">Most #TRENDING Collection 2025</p>
                                          
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Durgapujareddress_womens} className="card-img-top" alt="Durgapujareddress_womens"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Deep Pink                                </h5>
                                                <p className="card-text">This Sharod Utsav, adorn yourself in a new style.</p>
                                              
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
   <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={purpledress} className="card-img-top" alt="purpledress"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Trending Saree Prple</h5>
                                                <p className="card-text">2025 Durga Puja New Collection</p>
                                             

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={redpinkprnited} className="card-img-top" alt="redpinkprnited"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Printed Saptami Collection </h5>
                                                <p className="card-text">2025 Durga Puja </p>
                                              
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={churidar} className="card-img-top" alt="churidar"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Churidar Collection</h5>
                                                <p className="card-text">Most #TRENDING Collection 2025</p>
                                          
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Churidarwhite} className="card-img-top" alt="Churidarwhite"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >White Churidar                              </h5>
                                                <p className="card-text">This Sharod Utsav Collection </p>
                                              
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

 <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={lightpurple} className="card-img-top" alt="lightpurple"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Trending Saree Prple</h5>
                                                <p className="card-text">2025 Durga Puja New Collection</p>
                                             

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={maroondress} className="card-img-top" alt="maroondress"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Maroon Sweet Collection </h5>
                                                <p className="card-text">New Arrival </p>
                                              
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                     
                    </div>
                </div>
            </div>
            <br />
        </div>
    )
}

export default Durgapuja2025